import { type OpenApiSchemaCommunication } from '#shared/api/schema';

type PageCondition = OpenApiSchemaCommunication['conditions']['pages'][number];

const matchesPathname = (pattern: string, pathname: string): boolean => {
    /**
     * Поддерживаем два формата pathname:
     * - /products — только этот путь, без вложенных страниц;
     * - /products/* — любой путь, начинающийся с /products/, включая вложенные уровни.
     * /products/* не включает сам /products и разделы вроде /products-archive.
     * Сравнение учитывает регистр и завершающий слеш.
     * Параметры :id и другие конструкции URLPattern не интерпретируем: кроме конечного /* всё сравнивается буквально.
     */
    if (pattern.endsWith('/*')) {
        return pathname.startsWith(pattern.slice(0, -1));
    }

    return pathname === pattern;
};

/*
 * Query задаётся отдельно от pathname: все пары обязательны, значения точные и с учётом регистра.
 * Дополнительные параметры URL разрешены; при повторе ключа сравниваем его первое значение.
 * Шаблоны в query не поддерживаются.
 */
const matchesPage = (page: PageCondition, pathname: string, searchParams: URLSearchParams): boolean =>
    matchesPathname(page.pathname, pathname) &&
    Object.entries(page.query).every(([name, value]) => searchParams.get(name) === value);

export const matchesCommunication = (
    communication: OpenApiSchemaCommunication,
    pathname: string,
    searchParams: URLSearchParams,
    dismissedIds: ReadonlySet<string>
): boolean => {
    if (dismissedIds.has(communication.id)) {
        return false;
    }

    const { pages } = communication.conditions;

    return pages.length === 0 || pages.some((page) => matchesPage(page, pathname, searchParams));
};
